// launcherCatalog.js
// Shared data for the STEM Missions and Summer Camp Journeys launcher pills
// on the new Home screens. Moved from StemMissionLauncher.js and
// SummerCampJourneyLauncher.js (see docs/superpowers/specs/2026-09-16-home-redesign.md
// §3); every original field is kept byte-identical, with an `icon` field
// added per item. The originals stay in place until WP6 deletes them.

export const STEM_MISSIONS = [
  {
    mission: 1,
    title: "Flood Rescue Bridge",
    slug: "flood-rescue-bridge",
    storyTitle: "The Flood Rescue Bridge Mission",
    description: "Turn one sheet of paper into a rescue bridge, test it, and improve it with evidence.",
    accent: "#0f766e",
    softBackground: "#f0fdfa",
    darkBackground: "rgba(15,118,110,0.17)",
    icon: "bridge",
  },
  {
    mission: 2,
    title: "Electric Spiral",
    slug: "electric-spiral-mission",
    storyTitle: "The Electric Spiral Mission",
    description: "Explore circuits, energy, and motion through an engineering challenge.",
    accent: "#7c3aed",
    softBackground: "#f5f3ff",
    darkBackground: "rgba(124,58,237,0.16)",
    icon: "flash",
  },
  {
    mission: 3,
    title: "Conductive Dough",
    slug: "conductive-dough-mission",
    storyTitle: "The Conductive Dough Mission",
    description: "Build and investigate working circuits using conductive materials.",
    accent: "#c2410c",
    softBackground: "#fff7ed",
    darkBackground: "rgba(194,65,12,0.16)",
    icon: "flask",
  },
  {
    mission: 4,
    title: "Wind-Powered Car",
    slug: "wind-powered-car-mission",
    storyTitle: "The Air-Push Rescue Rover",
    description: "Build, test, and improve a battery-powered rover while proving how its propeller pushes air.",
    accent: "#0369a1",
    softBackground: "#e0f2fe",
    darkBackground: "rgba(3,105,161,0.18)",
    icon: "weather-windy",
  },
  {
    mission: 5,
    title: "Robot Artist",
    slug: "robot-artist-mission",
    storyTitle: "The Robot Artist Mission",
    description: "Engineer a drawing robot and use evidence to explain and improve its motion.",
    accent: "#15803d",
    softBackground: "#f0fdf4",
    darkBackground: "rgba(21,128,61,0.16)",
    icon: "robot",
  },
];

export const SUMMER_CAMP_DAYS = [
  {
    day: 1,
    campTitle: "Kickoff & Foundations",
    slug: "electric-spiral",
    storyTitle: "The Mystery of the Sleeping Wind Engine",
    accent: "#7c3aed",
    softBackground: "#f5f3ff",
    darkBackground: "rgba(124,58,237,0.16)",
    icon: "flag",
  },
  {
    day: 2,
    campTitle: "Lights, Circuits & Conductivity",
    slug: "conductive-dough",
    storyTitle: "The Great Glow City Blackout",
    accent: "#c2410c",
    softBackground: "#fff7ed",
    darkBackground: "rgba(194,65,12,0.16)",
    icon: "lightbulb-on-outline",
  },
  {
    day: 3,
    campTitle: "Energy & Engineering",
    slug: "wind-powered-car",
    storyTitle: "The Air-Push Rescue Rover",
    accent: "#0369a1",
    softBackground: "#e0f2fe",
    darkBackground: "rgba(3,105,161,0.18)",
    icon: "battery-charging",
  },
  {
    day: 4,
    campTitle: "Use All Learnings & Assemble Robot",
    slug: "mystery-of-the-robot-artist",
    storyTitle: "The Mystery of the Robot Artist",
    accent: "#15803d",
    softBackground: "#f0fdf4",
    darkBackground: "rgba(21,128,61,0.16)",
    icon: "robot-industrial",
  },
];

// The two Summer Camp assessment test titles, used to tag a student's due
// tests as "Check-in" rows (see useStudentHomeData's deriveDueSoon, WP2).
export const CHECK_IN_TITLES = [
  "Summer Camp Science Check-In - Early",
  "Summer Camp Science Check-In - Final",
];
